import Box from '@mui/material/Box'
import { visuallyHidden } from '@mui/utils'

// Mantener montado antes del guardado para anunciar los cambios de contenido.
export default function SavingStatus({ isSaving = false, label = 'Guardando...' }) {
  return (
    <Box component="span" role="status" aria-live="polite" aria-atomic="true" sx={visuallyHidden}>
      {isSaving ? label : ''}
    </Box>
  )
}
